import React from 'react'
import { makeStyles } from '@material-ui/core/styles'

import Timeline from '@material-ui/lab/Timeline'
import TimelineItem from '@material-ui/lab/TimelineItem'
import TimelineSeparator from '@material-ui/lab/TimelineSeparator'
import TimelineConnector from '@material-ui/lab/TimelineConnector'
import TimelineContent from '@material-ui/lab/TimelineContent'
import TimelineOppositeContent from '@material-ui/lab/TimelineOppositeContent'
import TimelineDot from '@material-ui/lab/TimelineDot'
import PublicIcon from '@material-ui/icons/Public'
import Chip from '@material-ui/core/Chip'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import Container from '@material-ui/core/Container'

import {
  TRIPS,
  GOOGLE_MAPS_TOKEN,
} from '../data'

const useStyles = makeStyles(theme => ({
  root: {
    
  },
  title: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
    textAlign: 'center',
  },
  paper: {
    padding: '6px 16px',
  },
  secondaryTail: {
    backgroundColor: theme.palette.secondary.main,
  },
  map: {
    '& iframe': {
      border: '0',
      width: '100%',
      minHeight: '300px',
      [theme.breakpoints.down('sm')]: {
        minHeight: '150px',
      },
    }
  },
  cauldronLink: {
    color: 'blue',
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
    textAlign: 'center',
    textDecoration: 'underline',
  },
  mapTitle: {
    marginBottom: theme.spacing(1),
  }

}))

const Home = ({

}) => {
  const classes = useStyles()

  return (
    <div className={ classes.root }>
      <Container maxWidth="lg">
        <a href="/cauldron">
          <Typography
            variant="h4"
            color="primary"
            className={ classes.cauldronLink }
          >
            Click Here for the Daily Cauldron
          </Typography>
        </a>
        <Typography
          variant="h4"
          color="primary"
          className={ classes.title }
        >
          Trips Together
        </Typography>
        <Timeline align="alternate">
          {
            TRIPS.map((trip, i) => {
              return (
                <TimelineItem key={ i }>
                  <TimelineOppositeContent>
                    <Typography variant="h6" component="h1" color="primary" className={classes.mapTitle}>
                        { trip.title }
                      </Typography>
                    <Typography variant="body1" component="h1" color="textSecondary">
                      <Chip size="small" label={ new Date(trip.from).toLocaleDateString() } variant="outlined" />
                      &nbsp;to&nbsp;
                      <Chip size="small" label={ new Date(trip.to).toLocaleDateString() } variant="outlined" />
                    </Typography>
                  </TimelineOppositeContent>
                  <TimelineSeparator>
                    <TimelineDot>
                      <PublicIcon />
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent>
                    <Paper elevation={3} className={classes.paper}>
                      {
                        trip.map && (
                          <div className={ classes.map }>
                            <iframe
                              loading="lazy"
                              allowFullScreen
                              src={ `https://www.google.com/maps/embed/v1/place?q=${trip.map}&key=${GOOGLE_MAPS_TOKEN}` }
                            >
                            </iframe>
                          </div>
                        )
                      }
                    </Paper>
                  </TimelineContent>
                </TimelineItem>
              )
            })
          }
        </Timeline>
      </Container>
      
    </div>
  )
}

export default Home